import script from "./WorkspaceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceModal.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceModal.vue?vue&type=style&index=0&id=3ac6795a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac6795a"]])

export default __exports__